<template>
	<div id="page">

		<Header></Header>

		<div id="productBanner" class="pcShow">
			<div class="container">
				<div class="txt">
					<div class="p1">专业更出色</div>
					<div class="p2">多样化产品印制</div>
					<div class="p3">超过200位专业技术人员服务于得胜彩印各个业务领域，<br>
					产品涵盖各类精品盒、包装盒、手提纸袋、精装画册、宣传彩页、产品说明书、纸箱、展柜等。<br>
					拥有先进的德国、日本进口印刷设备，<br>
					提供集设计、制版、印刷、装订和后道加工为一体的一站式全方位服务。</div>
				</div>
			</div>
		</div>

		<div id="mobileBanner" class="mobileShow">
			<img :src="imgPrefix + 'static/mobile_product_banner.jpg'" style="width: 100%;">
			<div class="txt">
				超过200位专业技术人员服务于得胜彩印各个业务领域，产品
涵盖各类精品盒、包装盒、手提纸袋、精装画册、宣传彩页、
产品说明书、喷绘、纸箱、展柜等。拥有先进的德国、
日本进口印刷设备，提供集设计、制版、印刷、装订和后道加
工为一体的一站式全方位服务。
			</div>
		</div>

		<div class="product-cate">
			<ul class="container">
				<li v-for="(item, index) in this.productCategorys">
<!--					<a :href="'#floor-'+(index+1)">-->
          <a @click="goProductAnchor('/product.html', 'floor-'+(index+1))" style="cursor: pointer;">
            <div class="icon">
              <img :src="imgPrefix + 'static/product_icon'+(index+1)+'.jpg'">
            </div>
            <div class="txt">
              <h2>{{ item.cname }}</h2>
              <p v-html="item.short_desc"></p>
            </div>
					</a>
				</li>
			</ul>
		</div>

		<div id="cate-floor">
			<div v-for="(item, index) in this.productCategorys" :class="'floor floor-'+(index+1)" :id="'floor-'+(index+1)">
				<div class="banner pcShow">
					<div class="bg"></div>
					<div class="txt">
						<h2>{{ item.sname }}</h2>
						<p>{{ item.sdname }}</p>
					</div>
				</div>
				<div class="mobile_cate_banner mobileShow">
					<img :src="imgPrefix + 'static/mobile_cate_banner0'+(index+1)+'.jpg'">
					<div class="txt">
						<h2>{{ item.sname }}</h2>
						<p>{{ item.sdname }}</p>
					</div>
				</div>
				<div class="container pcShow">
					<div class="product-list pcShow">
						<div class="left">
							<div class="img">
								<img :src="productImgPrefix + item.products[0].product_s_img" v-if="item.products && item.products.length > 0">
							</div>
							<div class="txt">
								<h2><img :src="imgPrefix + 'static/num'+(index+1)+'.jpg'"><b>{{ item.cname }}</b></h2>
								<p>{{ item.description }}</p>
								<router-link :to="'/product/'+item.id+'.html'" class="moreBtn">
									更多案例
								</router-link>
							</div>
						</div>
						<div class="right">
							<ul>
								<li v-for="(pro, index) in item.products" v-if="index > 0">
									<img :src="productImgPrefix + pro.product_s_img">
								</li>
							</ul>
						</div>
					</div>
				</div>

				<!--手机端 S-->
				<div class="mobile-product-list mobileShow">
					<div class="txt">
            {{ item.description }}
					</div>
					<ul>
						<li v-for="(pro, index) in item.products">
							<img :src="productImgPrefix + pro.product_s_img">
						</li>
					</ul>
          <router-link :to="'/product/'+item.id+'.html'" class="more">
            更多案例
          </router-link>
				</div>
				<!--手机端 E-->
			</div>
		</div>

		<div class="footer_bg pcShow"></div>

		<div class="mobileShow">
			<img :src="imgPrefix + 'static/mobile_footer_bg.jpg'" style="width: 100%;">
		</div>

		<Footer></Footer>

	</div>
</template>

<script>
	import Header from '../../components/Header.vue';
	import Footer from '../../components/Footer.vue';

  import { getProductCategoryList, getProductList } from '../../axios/api';

	export default {
    data() {
      return{
        imgPrefix: process.env.PREFIX_IMG,
        productImgPrefix: process.env.PREFIX_IMG + 'product/',
        product_categorys: [],
        products: [],
      }
    },

    components: {
      Header,
      Footer
    },

    computed: {
      productCategorys() {
        return this.product_categorys.sort(function(a,b){ return a.sort - b.sort })
      },
    },

    watch: {
      $route() {
        this.$nextTick(() => { this.getProductAnchor()});
      }
    },
    created(){
      // console.log(window.location.href)
      // this.$router.push({ path: window.location.href })
      // window.location.href=window.location.href
    },
    mounted() {
      this.getProductCategorys();
	    $("#nav ul li:nth-child(2) a.parent").addClass("router-link-exact-active")

      this.$nextTick(function () {
        window.addEventListener('scroll', this.handleScroll)
      })
    },
    updated() {
      this.$nextTick(() => { this.getProductAnchor()});
    },

    methods: {
      goProductAnchor(path, id) {
        localStorage.setItem("anchorId", id);
        this.$router.push({ path: path + '?' + id});
      },
      getProductAnchor(){
        let select = localStorage.getItem("anchorId");
        let elm = document.getElementById(select);
        if (select && elm) {
          elm.scrollIntoView(true);
          localStorage.setItem('anchorId', '')
        }
      },

      async getProductCategorys(){
        getProductCategoryList({sort: 'sort', order: 'asc', filter_params: {'display_state': 1}}).then(response => {
          const return_categorys = response.data.data.list;

          for (var i = 0; i < return_categorys.length; i++) {
            var category_id = return_categorys[i].id
            if (category_id) {
              this.getProducts(return_categorys[i])
            }
          }
        });
      },

      async getProducts(catetory){
        getProductList({pageNo: 1, pageSize: 5, sort: 'product_sort', order: 'asc', filter_params: {'product_category': catetory.id, 'product_display': 1, 'product_recommend': 1}}).then(response => {
          catetory.products = response.data.data.list;
		  if(window.screen.width>450){
			  catetory.short_desc = catetory.short_desc.replace(/\s+|，/ig, '<br/>')
		  }
          else{
			  catetory.short_desc = catetory.short_desc.replace(/\s+|，/ig, '')
		  }
          this.product_categorys.push(catetory)
        });
      }
    }
	}
</script>

<style scoped="">
	.footer_bg{
		height: 332px;
		background: url('https://img.ds-cy.com/static/footer_bg.jpg') no-repeat;
		background-position: top center;
	}
	.floor .banner{
		height: 333px;
		background: url('https://img.ds-cy.com/static/product_cate_banner01.jpg') no-repeat;
		background-position: top center;
		position: relative;
	}
	.floor-2 .banner{
		height: 333px;
		background: url('https://img.ds-cy.com/static/product_cate_banner02.jpg') no-repeat;
		background-position: top center;
		position: relative;
	}
	.floor-3 .banner{
		height: 333px;
		background: url('https://img.ds-cy.com/static/product_cate_banner03.jpg') no-repeat;
		background-position: top center;
		position: relative;
	}
	.floor-4 .banner{
		height: 333px;
		background: url('https://img.ds-cy.com/static/product_cate_banner04.jpg') no-repeat;
		background-position: top center;
		position: relative;
	}
	.floor .banner .bg{
		position: absolute;
		width: 100%;
		height: 100%;
		background:rgba(0,0,0,.2);
		top: 0;
		left: 0;
	}
	.floor .banner .txt{
		text-align: center;
		color: #fff;
		position: absolute;
		width: 100%;
		top: 50%;
		-webkit-transform: translate(0, -52%);
	}
	.floor .banner .txt h2{
		font-size: 52px;
		position: relative;
		padding-bottom: 22px;
		margin-bottom: 36px;
		letter-spacing: 2px;
	}
	.floor .banner .txt h2::after{
		content: '';
		width: 80px;
		height: 1px;
		background: #fff;
		left: 50%;
		margin-left: -40px;
		position: absolute;
		bottom: 0;
	}
	.floor .banner .txt p{
		margin-bottom: 0;
		font-size: 22px;
	}

	.product-list{
		margin: 80px 0;
		min-height: 0;
		overflow: hidden;
	}

	.product-list .left{
		width: 32.89%;
		float: left;
	}

	.product-list .left .img{
		margin-bottom: 40px;
		overflow: hidden;
	}

	.product-list .left img{
		width: 100%;
		height: auto;
		transition: all linear 200ms;
	}

	.product-list .left .img:hover img{
		transform: scale(1.1);
	}

	.product-list .left  h2 img{
		width:auto
	}

	.product-list .right ul li{
		width: 49.4%;
		float: left;
		margin-bottom: 10px;
		overflow: hidden;
	}

	.product-list .right ul li:hover img{
		transform: scale(1.1);
	}

	.product-list .right{
		width: 66.4%;
		float: right;
	}

	.product-list .right ul li img{
		width: 100%;
		height: auto;
		transition: all linear 200ms;
	}

	.product-list .right ul li:nth-child(2n){
		float: right;
	}

	.floor-2 .product-list .left .txt{
		margin-left: 8%;
	}


	.floor-4 .product-list .left .txt{
		margin-left: 8%;
	}

	.floor-4 .product-list .left{
		float: right;
	}

	.floor-4 .product-list .right{
		float: left;
	}

	.floor-5 .product-list .left{
		float: left !important;
	}

	.floor-5 .product-list .right{
		float: right !important;
	}

	.floor-6 .product-list .left{
		float: right !important;
	}

	.floor-6 .product-list .right{
		float: left !important;
	}

	.floor-5 .banner{
		background: url('https://img.ds-cy.com/static/product_cate_banner05.jpg') no-repeat;
		background-position: top center;
	}

	.floor-6 .banner{
		background: url('https://img.ds-cy.com/static/product_cate_banner06.jpg') no-repeat;
		background-position: top center;
	}

	.floor-6 .product-list .left .txt{
		margin-left: 8%;
	}

	#productBanner{
		height: 515px;
		background: url('https://img.ds-cy.com/static/product_banner3.jpg') no-repeat;
		background-position: top center;
	}

	#productBanner .txt{
		padding-top: 95px;
	}

	#productBanner .txt div{
		color: #fff;
	}

	#productBanner .txt .p1{
		font-size: 50px;
		margin-bottom: -10px;
	}

	#productBanner .txt .p2{
		font-size: 50px;
		padding-bottom: 20px;
		position: relative;
	}

	#productBanner .txt .p2::after{
		content: '';
		bottom: 0;
		left: 0;
		position: absolute;
		width: 95px;
		height: 4px;
		background: #ff9900;
	}

	#productBanner .txt .p3{
		font-size: 14px;
		line-height: 30px;
		margin-top: 35px;
	}

	.product-cate{
		min-height: 182px;
		overflow: hidden;
		margin-top: 68px;
		margin-bottom: 55px;
	}

	.product-cate ul li{
		width: 16.6666%;
		float: left;
		text-align: center;
	}

	.product-cate ul li .icon{
		width: 85px;
		margin: auto;
		margin-bottom: 15px;
	}

	.product-cate ul li .txt h2{
		font-size: 24px;
		color: #333333;
		margin-bottom: 5px;
		margin-bottom: 12px;
	}
	.product-cate ul li .txt p{
		font-size: 14.5px;
		color: #999999;
		max-width: 210px;
		margin: auto;
	}
	.product-list .left h2 img{
		float: left;
	}
	.product-list .left h2 b{
		float: left;
		font-weight: normal;
		font-size: 24px;
		color: #00a0e9;
		margin-left: 20px;
		position: relative;
		top: 42px;
	}
	.product-list .left h2{
		width: 100%;
		min-height: 0;
		margin-bottom: 15px;
		overflow: hidden;
	}
	.product-list .left p{
		font-size: 16px;
		color: #666666;
	}
	.product-list .left .txt{
		width: 84%;
		line-height: 26px;
		/* margin-left: 3.8%; */
		padding-top: 5px;
	}
	.product-list .left .txt .moreBtn{
		width: 220px;
		line-height: 53px;
		border: 1px solid #cccccc;
		display: block;
		font-size: 16px;
		color: #00a0e9;
		text-align: center;
		text-decoration: none;
		margin-top: 75px;
		transition: all linear 200ms;
	}
	.product-list .left .txt .moreBtn:hover{
		background: #00a0e9;
		border: 1px solid #00a0e9;
		color: #fff;
	}
	#cate-floor .floor:nth-of-type(2n) .left{
		float: right;
	}

	#cate-floor .floor:nth-of-type(2n) .right{
		float: left;
	}

	#mobileBanner .txt{
		font-size: 12px;
		padding: 5% 7%;
		background: #245e9c;
		color: #fff;
	}

	.mobile_cate_banner img{width: 100%;}

	.mobile-product-list{
		padding: 12px 0 28px 15px;
	}

	.mobile-product-list ul li img{
		height: 200px;
	}
	.mobile-product-list ul{
		white-space: nowrap;
		overflow-x: scroll;
		width: 100%;
	}

	.mobile-product-list ul li{
		display: inline-block;
		margin-right: 5px;
		white-space: initial;
	}

	.mobile-product-list ul li:last-child{
		margin-right: 0;
	}

	.mobile-product-list .txt{
		font-size: 14px;
		line-height: 22px;
		color: #666666;
		margin-bottom: 20px;
		margin-right: 15px;
	}

	.mobile-product-list .more{
		display: block;
		border: 1px solid #ddd;
		line-height: 35px;
		color: #666;
		text-align: center;
		margin-right: 15px;
		font-size: 15px;
		margin-top: 15px;
	}

	#floor-3 .left .txt .moreBtn{
		margin-top: 100px;
	}

	#floor-5 .left .txt .moreBtn{
		margin-top: 100px;
	}

	#floor-6 .left .txt .moreBtn{
		margin-top: 100px;
	}

	@media (max-width:1199px) {
		.product-list .left p{
			display: none;
		}
		.product-list .left .txt .moreBtn{
			width: 100%;
			margin-top: 30px;
		}
		.product-list .left h2{
			margin-top: 13px;
			margin-bottom: 34px;
		}
		.product-list .left h2 img{
			height: 60px;
		}
		.product-list .left h2 b{
			top: 33px;
		}
		.product-list .right ul li{
			margin-bottom: 6px;
		}
		.product-list .left .img{
			margin-bottom: 34px;
		}
		#floor-3 .left .txt .moreBtn{
			margin-top: 30px;
		}
		#floor-5 .left .txt .moreBtn{
			margin-top: 30px;
		}
		#floor-6 .left .txt .moreBtn{
			margin-top: 30px;
		}
	}

	@media (max-width:991px) {
		.product-list .left h2{
			margin-top: 0;
			margin-bottom: 0;
		}
		.product-cate ul li{
			width: 30%;
			text-align: center;
			margin-left: 2.5%;
		}
		.product-cate ul li .icon{
			float: initial;
			width: 100%;
		}
		.product-cate{
			margin: 40px 0 20px 0;
		}
		.product-cate ul li .icon img{
			width: 60px;
		}
		.product-cate ul li .txt h2{
			font-size: 16px;
			margin-bottom: 5px;
			margin-top: 5px;
		}
		.product-cate ul li .txt p{
			font-size: 9px;
			margin-bottom: 20px;
		}
		#productBanner .txt .p1{
			font-size: 35px;
		}
		#productBanner .txt .p2{
			font-size: 35px;
			padding-bottom: 15px;
		}
		#productBanner .txt .p2::after{
			width: 70px;
			height: 3px;
		}
		#productBanner{
			height: 480px;
		}
		.floor .banner .txt h2{
			font-size: 40px;
		}
		.floor .banner .txt p{
			font-size: 20px;
		}
	}

	@media (max-width:767px) {
		.mobile_cate_banner{
			position: relative;
		}
		.mobile_cate_banner .txt{
			position: absolute;
			width: 100%;
			left: 0;
			top: 0;
			text-align: center;
			top: 50%;
			-webkit-transform: translate(0, -52%);
		}
		.mobile_cate_banner .txt h2{
			color: #fff;
			padding-bottom: 14px;
			margin-bottom: 15px;
			position: relative;
			font-size: 28px;
		}
		.mobile_cate_banner .txt h2::after {
		    content: '';
		    width: 50px;
		    height: 1px;
		    background: #fff;
		    left: 50%;
		    margin-left: -25px;
		    position: absolute;
		    bottom: 0;
		}
		.mobile_cate_banner .txt p{
			color: #fff;
			margin-bottom: 0;
		}
		.mobile-product-list .more{
			width: 140px;
			margin: auto;
			margin-top: 18px;
		}


		.floor .banner .txt h2{
			font-size: 30px;
			padding-bottom: 15px;
			margin-bottom: 20px;
		}
		.floor .banner .txt h2::after{
			width: 50px;
			margin-left: -25px;
		}
		.floor .banner .txt p{
			font-size: 15px;
		}
		.floor .banner{
			height: 200px;
		}
		.product-list .left h2{
			display: none;
		}
		.product-list .left .txt{
			width: 100%;
		}
		.mobile-product-list .txt{
			margin-bottom: 15px;
		}

	}
	
	
	@media (max-width:450px) {
		.product-cate ul li br{
			display: none;
		}
	}
</style>




// WEBPACK FOOTER //
// src/page/product/product.html.vue